export const BENZINGA_RECOGNITION_TEXT = '6x Benzinga Fintech Awards finalist';

export interface BenzingaAwardBadge {
  src: string;
  alt: string;
}

export const BENZINGA_AWARD_BADGES: BenzingaAwardBadge[] = [
  {
    src: '/images/benzinga-2023-1.png',
    alt: 'Benzinga Global Fintech Awards finalist, Best Data Analysis Tool',
  },
  {
    src: '/images/benzinga-2023-2.png',
    alt: 'Benzinga Global Fintech Awards finalist, Best Investment Research',
  },
  {
    src: '/images/benzinga-2023-3.png',
    alt: 'Benzinga Global Fintech Awards finalist, Best For Swing Trading',
  },
  {
    src: '/images/benzinga-2023-4.png',
    alt: 'Benzinga Global Fintech Awards finalist, Best For Trading Cryptocurrency',
  },
  {
    src: '/images/benzinga-2023-5.png',
    alt: 'Benzinga Global Fintech Awards finalist, Breaking Barriers',
  },
  {
    src: '/images/benzinga-2022-1.png',
    alt: 'Benzinga Global Fintech Awards finalist 2022',
  },
];
